import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import classNames from "classnames";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressSpinner } from "primereact/progressspinner";
import { Rating } from "primereact/rating";

import { FaChevronLeft } from "react-icons/fa";
import { FaCheck, FaChevronRight } from "react-icons/fa6";

import { useInfo } from "../../../../context/infoContext";
import { Api } from "../../../../services/api";

import { associado_id, userInfo } from "../../../../services/authHandlers";


export const PopupPesquisa = () => {
  const { associadoInfo,
    providerInfo,
    showPopup,
    setShowPopup,
    feedbackAmount
  } = useInfo();

  const [loading, setLoading] = useState(false);
  const [tabPesquisa, setTabPesquisa] = useState(0);

  useEffect(() => {
    if (feedbackAmount) {
      // console.log('associadoInfo', associadoInfo)
      setTabPesquisa(1)
    }
  }, [feedbackAmount])


  // parametros para registro

  const [checkListSatisfacao, setCheckListSatisfacao] = useState(0);
  const [checkListIndicacao, setCheckListIndicacao] = useState(0);
  const [comentario, setComentario] = useState('')


  //function
  const registraFeedback = async () => {
    setLoading(true)
    try {
      const associado_operador_id = userInfo.associado_id || associado_id
      if (checkListIndicacao === 0 || checkListSatisfacao === 0)
        return toast.error('Notas não registradas')

      const parametros = {
        satisfacao: checkListSatisfacao,
        indicacao: checkListIndicacao,
        comentario: comentario,
      }

      for (const [tipo, nota_comentario] of Object.entries(parametros)) {
        const body = {
          associado_id: associado_operador_id
        }
        if (!nota_comentario) continue;
        if (tipo != 'comentario') {
          body.tipo = tipo;
          body.nota = nota_comentario;
        } else {
          body.tipo = tipo;
          body.comentario = nota_comentario;
        }

        await Api.post('/pesquisa/registrar', body);
      }
      toast.success('Agradecemos sua colaboração!')
    } catch (error) {
      console.error(error)
      console.log(error)
      if (!(error.response)) toast.error('Erro 500')
      toast.error(error.response.data.error)
    } finally {
      setShowPopup(false)
      setLoading(false)
    }
  };

  const verifyLimit = (value) => {
    if (value.length <= 250) {
      setComentario(value)
    }
  };

  //template
  const headerPopup = (
    <div className="p-0 m-0">
      <h5 className="text-center m-0">
        Dê seu feedback
      </h5>
    </div>
  );

  const showUserName = () => {
    if (associadoInfo)
      if (associadoInfo.associado_nome)
        return associadoInfo.associado_nome
    if (providerInfo.personal) {
      if (providerInfo.personal.usuario_nome)
        return providerInfo.personal.usuario_nome
      if (providerInfo.personal.nome_fantasia)
        return providerInfo.personal.nome_fantasia
    }
  };

  const footerPopup = () => {
    return (
      <div className={tabPesquisa === 1 || tabPesquisa === 2 ? "flex justify-between w-full" : "flex justify-end w-full"}>
        {(tabPesquisa > 0) && <Button
          rounded
          icon={<FaChevronLeft />}
          onClick={() => setTabPesquisa(tabPesquisa - 1)}
          disabled={loading}
        />}
        {tabPesquisa < 2 && <Button
          rounded
          icon={<FaChevronRight />}
          onClick={() => setTabPesquisa(tabPesquisa + 1)}
        />}
        {tabPesquisa === 2 && <Button
          severity="success"
          icon={<FaCheck />}
          disabled={(checkListIndicacao === 0 || checkListSatisfacao === 0 || loading)}
          onClick={() => registraFeedback()}
        />}
      </div>
    )

  }
  return (
    <Dialog
      visible={showPopup}
      header={headerPopup}
      footer={footerPopup}
      position="bottom-left"
      onHide={() => setShowPopup(false)}
      pt={{
        root: ({ state, props }) => ({
          className: classNames('rounded-lg shadow-lg border-0',
            'transform scale-100',
            'flex flex-col w-[24rem] h-[21rem] overflow-y-scroll',
            'm-0 z-50 pointer-events-auto',
            'ml-2 mb-2',
            'overflow-hidden',
            'dark:border dark:border-blue-900/40', {
            'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized,
            '': !props.modal
          })
        }),
        mask: ({ props }) => ({
          className: classNames({ '': !props.modal })
        }),
        content: ({ state }) => ({
          className: classNames('h-full', 
            'bg-white text-gray-700 px-6 pb-8 pt-0', 
            'rounded-bl-lg rounded-br-lg', 
            'dark:bg-gray-900  dark:text-white/80 ', {
            grow: state.maximized
          })
        }),
        footer: {
          className: classNames('shrink-0 ',
            'relative z-50 pointer-events-auto',
            'border-t-0 bg-white text-gray-700 px-6 pb-6 text-right rounded-b-lg',
            'dark:bg-gray-900 dark:text-white/80')
        },
      }}
      modal={false}
      draggable={false}
    >
      {loading && <div className="flex justify-center"> <ProgressSpinner className="w-11rem h-11rem" /> </div>}

      {
        (tabPesquisa === 0 && !loading) &&
        <div className="w-full">
          <p>Olá! {showUserName()}<br />
            Queremos ouvir você! Dê sua opinião sobre nossos serviços em dois cliques.</p>
          <p>Para prosseguir aperte o botão abaixo.</p>
        </div>
      }
      {
        (tabPesquisa === 1 && !loading) &&
        <div className="w-full grid gap-4">
          <h6>Satisfação com o serviço</h6>
          <div className="flex flex-row justify-center">
            <Rating
              pt={{
                item: ({ props, context }) => ({
                  className: classNames(
                    'inline-flex items-center',
                    {
                      'cursor-pointer': !props.readOnly,
                      'cursor-default': props.readOnly
                    },
                    {
                      'outline-none outline-offset-0 shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]': context.focused
                    }
                  )
                }),
              }}
              value={checkListSatisfacao}
              onChange={(e) => setCheckListSatisfacao(e.value)}
              stars={10}
              cancel={false} />
          </div>
          <h6>O quanto você indicaria os nossos serviços?</h6>
          <div className="flex flex-row justify-center">
            <Rating
              pt={{
                item: ({ props, context }) => ({
                  className: classNames(
                    'inline-flex items-center',
                    {
                      'cursor-pointer': !props.readOnly,
                      'cursor-default': props.readOnly
                    },
                    {
                      'outline-none outline-offset-0 shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]': context.focused
                    }
                  )
                }),
              }}
              value={checkListIndicacao}
              onChange={(e) => setCheckListIndicacao(e.value)}
              stars={10}
              cancel={false} />
          </div>
        </div>
      }
      {
        (tabPesquisa === 2 && !loading) &&
        <div className="w-full" style={{ display: "inline-block" }}>
          <div className="flex">
            <h6>Comentário</h6><span className="mx-1" style={{ color: '#71717A' }}>(opcional)</span>
          </div>
          <InputTextarea
            className="w-full h-20"
            value={comentario}
            onChange={(e) => verifyLimit(e.target.value)}
            autoResize={true}
          />
          <p className="w-full" style={{ textAlign: "end" }}>{comentario.length}/250</p>
        </div>
      }
    </Dialog>
  )
}

